export class MenuConfig {
  public defaults: any = {
    aside: {
      self: {},
      items: [
        {
          title: "Inicio / Home",
          root: true,
          icon: "flaticon2-architecture-and-city",
          page: "/dashboard",
        },
        {
          separator: true,
        },
        {
          title: "Parámetros / Settings",
          root: true,
          icon: "flaticon2-graphic-1",
          page: "/parametros",
          permission: "OWNER",
        },
        {
          title: "Aseguradora / Insurance Company",
          root: true,
          icon: "flaticon2-tools-and-utensils",
          page: "/aseguradora",
          permission: "OWNER",
        },
        {
          title: "Broker",
          root: true,
          icon: "flaticon2-avatar",
          page: "/intermediario",
          permission: "OWNER",
        },
        {
          title: "Usuario final / Final User",
          root: true,
          icon: "flaticon2-user-1",
          page: "/usuario",
          permission: "OWNER",
        },
        {
          title: "Póliza madre / Main Policy",
          root: true,
          icon: "flaticon2-sheet",
          page: "/poliza",
          permission: "OWNER",
        },
        {
          title: "Pólizas próximas a vencer / Next to Expire Policies",
          root: true,
          icon: "flaticon2-calendar-1",
          page: "/vencer",
          permission: "OWNER",
        },
        {
          title: "Generadores / Insured",
          root: true,
          icon: "flaticon2-soft-icons",
          page: "/generadores",
          permission: "FINAL",
        },
        {
          title: "Asegurar despacho / Get a Certificate",
          root: true,
          icon: "flaticon2-laptop",
          page: "/despacho",
          permission: "FINAL",
        },
        {
          title: "Reporte Despacho / Declared Shipments",
          root: true,
          icon: "flaticon2-infographic",
          page: "/reportes",
          permission: "FINAL",
        },
        {
          title: "Cotizaciones / Quote slips",
          root: true,
          icon: "flaticon2-sheet",
          page: "/borradores",
          permission: "FINAL",
        },
        {
          title: "Reporte Poliza Madre / Mother Policy Report",
          root: true,
          icon: "flaticon2-infographic",
          page: "/reportes-poliza-consolidado",
          permission: "BROKER",
        },
        {
          title: "Reporte Poliza Madre / Mother Policy Report",
          root: true,
          icon: "flaticon2-infographic",
          page: "/reportes-poliza-consolidado",
          permission: "COMPANY",
        },
        {
          title: "Detalle Despachos / Dispatch Detail",
          root: true,
          icon: "flaticon2-gear",
          page: "/detalle-poliza",
          permission: "BROKER",
        },
        {
          title: "Detalle Despachos / Dispatch Detail",
          root: true,
          icon: "flaticon2-gear",
          page: "/detalle-poliza",
          permission: "COMPANY",
        },
        {
          title: "Detalle Despachos / Dispatch Detail",
          root: true,
          icon: "flaticon2-gear",
          page: "/detalle-poliza",
          permission: "OWNER",
        },
        {
          title: "Reporte Aseguradora / Insurer Report",
          root: true,
          icon: "flaticon2-chart",
          page: "/reporte-aseguradora",
          permission: "OWNER",
        },
      ],
    },
  };

  public get configs(): any {
    return this.defaults;
  }
}
